import classNames from "classnames";
import { Button } from "../../../../../components/buttons/button";
import {
  DebitCard,
  DebitCardLoader,
} from "../../../../../components/cards/debitcard";
import { EmptyState } from "../../../../../components/states/emptyState";
import { TitleSub } from "../../../../../components/typography/titleSub";
import { useCardTokenization } from "../../../../../customHooks/useCardTokenization";
import { useGetUserDebitCardsQuery } from "../../../../../redux/features/payment/payment.api";

export const Cards = ({ className }: { className?: string }) => {
  const {
    data: userDebitCards,
    isLoading: loadingUserDebitCards,
    refetch: refetchUserDebitCards,
  } = useGetUserDebitCardsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const { initiatingCardTokenization, doCardTokenization } =
    useCardTokenization();

  return (
    <>
      <div className={classNames("px-4 md:px-8", className)}>
        <div className="flex flex-wrap gap-4 items-center justify-between">
          <TitleSub
            title="Debit Cards"
            subtitle={"Linked debit cards"}
            className={`w-fit md:max-w-max`}
          />

          <Button
            text="Add card"
            icon="plus"
            onClick={async () => {
              await doCardTokenization({
                onSuccess: () => {
                  refetchUserDebitCards();
                },
              });
            }}
            type="button"
            className="!min-w-[82px] md:!min-w-[107px] !w-fit ml-auto"
            size="medium"
            loading={initiatingCardTokenization}
            disabled={initiatingCardTokenization}
            variation="primary"
          />
        </div>

        {loadingUserDebitCards ? (
          <div className="mt-8 flex flex-col gap-2">
            {[1, 2].map((k) => {
              return <DebitCardLoader key={`${k}`} />;
            })}
          </div>
        ) : (
          <>
            {![0, undefined].includes(userDebitCards?.data?.length) ? (
              <div className="mt-8 flex flex-col gap-4">
                {userDebitCards?.data?.map((card, idx) => {
                  const key = `card-info-${idx}`;

                  return (
                    <DebitCard
                      cardDetails={card.CardDetail}
                      enableDelete
                      key={key}
                      onSuccess={() => {
                        refetchUserDebitCards();
                      }}
                      id={card.id}
                    />
                  );
                })}
              </div>
            ) : (
              <EmptyState
                image={
                  <img
                    src={"/assets/images/empty_state_bank.svg"}
                    alt="empty_state"
                    className=""
                  />
                }
                title="You have not linked any cards"
                className="mt-8 md:mt-20"
              />
            )}
          </>
        )}
      </div>
    </>
  );
};
